import styled from 'styled-components'
import { Radio } from 'antd'

export const Card = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`

export const Title = styled.h3`
  margin: 0 0 16px;
  color: #002a6d;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`

export const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  .ant-radio-wrapper {
    display: grid !important;
    grid-template-columns: 20px 1fr;
    column-gap: 4px;
    row-gap: 4px;
    margin: 0 !important;
    padding: 0;
    line-height: 20px;
    white-space: normal;
    height: auto;
    min-height: 0;

    &::after {
      display: none;
    }
  }

  .ant-radio {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
    justify-self: start;
    flex-shrink: 0;
    float: none;
    top: 0;
    margin: 0;
    line-height: 1;
  }

  .ant-radio + * {
    display: contents;
    padding: 0;
  }
`

export const OptionContent = styled.div`
  display: contents;
`

export const OptionTitle = styled.span`
  grid-column: 2;
  grid-row: 1;
  align-self: center;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`

export const OptionDescription = styled.span`
  grid-column: 2;
  grid-row: 2;
  color: #757575;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const NormativeOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const NormativeDetailsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const ApplicablePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px 24px;
  border-radius: 8px;
  background: #f5f5f5;
`

export const ApplicableLabels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ApplicableLabel = styled.span`
  color: #757575;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`

export const ApplicableValue = styled.span`
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`
